/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SqlVmNetworkInfo } from '../models/SqlVmNetworkInfo';

export class GetSqlVmNetworkInfoResponse {
  'networkInfo': SqlVmNetworkInfo;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "networkInfo",
      "baseName": "networkInfo",
      "type": "SqlVmNetworkInfo",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetSqlVmNetworkInfoResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

